import type { DashboardViewModel } from "./utils";
import { MembershipCard, PersonalInformationCard, WelcomeCard } from "./cards";
import { Banner } from "@dsaui/components";
import { PageShell } from "components/PageShell";

export interface DashboardLayoutProps {
  accountHref: string;
  loading?: boolean;
  membershipHref: string;
  viewModel: DashboardViewModel;
}

export function DashboardLayout({
  accountHref,
  loading = false,
  membershipHref,
  viewModel,
}: DashboardLayoutProps) {
  return (
    <PageShell className="max-w-sm gap-6 px-4 lg:max-w-3xl lg:gap-8 lg:px-0">
      {viewModel.membershipIsMerged && (
        <Banner variant="warning">
          <p>{viewModel.mergedAccountMessage}</p>
        </Banner>
      )}

      <WelcomeCard
        chapter={viewModel.chapter}
        email={viewModel.email}
        loading={loading}
        membershipStatus={viewModel.membershipStatus}
        membershipStatusIcon={viewModel.membershipStatusIcon}
        membershipStatusIsGoodStanding={viewModel.membershipStatusIsGoodStanding}
        name={viewModel.name}
        proofActionHref={viewModel.membershipProofActionHref}
        proofActionLabel={viewModel.proofActionLabel}
        showChapterTooltip={!viewModel.membershipIsMerged}
      />

      <div className="flex flex-col gap-6 lg:grid lg:grid-cols-2 lg:gap-8">
        <MembershipCard
          billingName={viewModel.billingName}
          billingDetails={viewModel.billingDetails}
          duesDetail={viewModel.duesDetail}
          cardExpiration={viewModel.cardExpiration}
          loading={loading}
          nextPaymentDate={viewModel.nextPaymentDate}
          paymentMethod={viewModel.paymentMethod}
          updateHref={membershipHref}
        />
        <PersonalInformationCard
          email={viewModel.email}
          loading={loading}
          mailingDetails={viewModel.mailingDetails}
          name={viewModel.name}
          phone={viewModel.phone}
          updateLabel={viewModel.profileActionLabel}
          updateHref={accountHref}
        />
      </div>
    </PageShell>
  );
}

export default DashboardLayout;
